"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFolderSize = exports.makeCollectionFromFS = void 0;
/**
 * Creates array in the format of Collection with data loaded from directory on filesystem.
 * The function loads all the data into memory!
 *
 * @param dir path to the directory
 */
async function makeCollectionFromFS(_dir) {
    throw new Error('Creating Collection from File System is not supported in browsers!');
}
exports.makeCollectionFromFS = makeCollectionFromFS;
/**
 * Calculate folder size recursively
 *
 * @param dir the path to the folder to check
 * @returns size in bytes
 */
async function getFolderSize(_dir) {
    throw new Error('Creating Collection from File System is not supported in browsers!');
}
exports.getFolderSize = getFolderSize;
